export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Falha ao ler o arquivo"));
    reader.onload = () => {
      const result = reader.result as string; // data:<mime>;base64,XXXX
      const base64 = result.split(",")[1] ?? ""; // pega só o conteúdo base64
      resolve(base64);
    };
    reader.readAsDataURL(file);
  });
}
